
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachDiagnosticsCategoriesListFormRemove} from "@/models/app/coach/diagnostics/categories/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnosticCategory",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachDiagnosticsCategoriesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  diagnosticCategory: AppCoachDiagnosticsCategoriesListFormRemove = new AppCoachDiagnosticsCategoriesListFormRemove();

  formData: AppCoachDiagnosticsCategoriesListFormRemove = new AppCoachDiagnosticsCategoriesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/diagnostic-category/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getDiagnosticCategories');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.diagnosticCategory;
  }

  resetFormData(): void {
    this.formData = new AppCoachDiagnosticsCategoriesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
